import * as alerts from '@redux/utils/alerts';
import { useEffect, useState } from 'react';
import { appIntl } from 'utility/context/IntlGlobalProvider';
import { insertBinnacleCommentService } from '../services';

const useInsertBinnacleComment = (
  execute: boolean = false,
  values: {
    entityTypeId: number;
    entityId: number;
    categoryId: number;
    comment: string;
  }
): {
  submittingSave: boolean;
} => {
  const [submittingSave, setIsFetching] = useState<boolean>(false);
  useEffect(() => {
    if (values.entityId && values.entityTypeId && values.comment) {
      setIsFetching(true);
      insertBinnacleCommentService(values, {
        errorAction: () => {
          const error = {
            errorMessage: appIntl().formatMessage({ id: 'entities.insertCommentFailure' }),
            errorNumber: 0
          };
          alerts.showErrorAlertFailChanges({ error });
          setIsFetching(false);
        },
        successAction: (response) => {
          if (response.success === true) {
            alerts.showSuccessMessage({
              success: appIntl().formatMessage({ id: 'entities.insertCommentSuccess' })
            });
            setIsFetching(false);
          } else {
            const error = {
              errorMessage: appIntl().formatMessage({ id: 'entities.insertCommentFailure' }),
              errorNumber: 0
            };
            alerts.showErrorAlertFailChanges({ error });
            setIsFetching(false);
          }
        }
      });
    }
  }, [execute]);
  return { submittingSave };
};

export default useInsertBinnacleComment;
